export default __webpack_public_path__ + "static/app-video-backround-fallback-7bf63d56d9ad063537498733ee651abb.jpg";